
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-view-dropdown-selector-v1',
    templateUrl: './view-dropdown-selector-v1.component.html'
})
export class ViewDropdownSelectorV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;


    ngOnInit(): void {
    }
    
}
